import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type State */
const initialState = false;

/**
 * @returns {State}
 */
const isLoading = () => true;

/**
 * @returns State
 */
const isEnded = () => false;

export default createReducer(initialState, {
  [types.GET_MODAL_DEALERS]: isLoading,
  [types.GET_MODAL_DEALERS_SUCCESS]: isEnded,
  [types.GET_MODAL_DEALERS_FAILURE]: isEnded,
});
